module.exports = __webpack_public_path__ + "img/logo-success3.4ed337b8.jpg";